// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

type BecomeADistributorState = ApplicationState["bunzl"]["components"]["becomeADistributor"];

const initialState: BecomeADistributorState = {
    isLoading: false,
};

const actions = {
    "Bunzl/Components/BecomeADistributor/BeginLoading": (draft: Draft<BecomeADistributorState>) => {
        draft.isLoading = true;
    },
    "Bunzl/Components/BecomeADistributor/FinishLoading": (draft: Draft<BecomeADistributorState>) => {
        draft.isLoading = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsBecomeADistributorFormActions = BunzlActionUnion<typeof actions>;
export default reducer;
